/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/6/19
 * Time: 11:53 PM
 */
import React, {Component} from 'react';
import {Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import {Icon, message, Spin, Tooltip} from "antd";
import {Button as SementicBtn, Checkbox, Form} from "semantic-ui-react";
import {MDBDataTable, MDBModal, MDBModalHeader, MDBModalBody} from "mdbreact";

import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import axiosVisitor from "../../../../axios/axios_visitortag";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import axiosTags from "../../../../axios/axios_tag";

import building_icon from "../../../../assets/img/recept_checkin/building.svg";
import floor_icon from "../../../../assets/img/recept_checkin/floor.svg";
import pass_icon from "../../../../assets/img/recept_checkin/pass.svg";
import cry_icon from "../../../../assets/img/sweet/cry.svg";
import Lbl from "../../../../components/Label/Lbl";
import apiConfig from "../../../../axios/axios_api_services";
import csvFormat from "../../../../assets/csv/csv_format_bulk_visitor.csv";
import Files from "react-files";
import base64 from "base-64";
import './styles.css'

let reg = /^\d+$/;

class App extends Component {
  state = {
    isSpin: false,
    allocated: '',
    cardIndex: '',
    status: true,
    updateCard: false,
    passId: '',
    cardObj: null,

    building: '',
    all_cards: [],
    building_list: [],
    floor: '',
    floor_options: [],
    card: '',
    selected_card_list: [],
    // new properties
    branch_list: [],
    selected_branch: "",
    json:[],
    isModal:false,
    selectedBulkEdit:null
  };

  handleChange = (name) => event => {
    let value = event.target.value;
    if (name === "cardIndex" || name === "cardIndex_") {
      if (reg.test(value) || value === "") {
        this.state.isModal ? this.state.selectedBulkEdit[name] = value : this.setState({ [name]: value});
      }
    } else {
      this.state.isModal ? this.state.selectedBulkEdit[name] = value : this.setState({ [name]: value});
    }
    if (this.state.isModal) this.forceUpdate();
  };

  clearFeilds = () => {
    this.setState({
      selected_branch: "",
      passId: '',
      allocated: '',
      cardIndex: '',
      status: true,
      updateCard: false
    })
  };

  convertDate = (date) => {
    let d = new Date(date);
    d = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
    return d;
  };

  getAllCards = () => {
    this.clearFeilds();
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosVisitor.get(apiConfig.CORPORATE_CARD(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            all_cards: response.data.cards
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllCards()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  addNewCard = () => {
    let {allocated, cardIndex, status, updateCard, passId, selected_branch} = this.state;
    const obj = {
      "did": cardIndex.toString(),
      "uid": null,
      "passId": passId,
      "regDate": this.convertDate(new Date()),
      "issueDate": this.convertDate(new Date()),
      "status": status ? "ACTIVE" : "INACTIVE",
      "allocated": allocated,
      "cardIndex": 0
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosVisitor.put(apiConfig.CORPORATE_CARD_CREATE({corporateId:this.props.usr_obj.corporateId,branchId:selected_branch}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.getAllCards();
        } else {
          common.warningAlert(response.data.message, 1);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.addNewCard()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  updateCard = () => {
    let {allocated, cardIndex, status, updateCard, passId, cardObj, selected_branch} = this.state;
    const obj = {
      "cardId": cardObj.cardId,
      "did": cardIndex.toString(),
      "uid": cardObj.uid,
      "passId": passId,
      "regDate": this.convertDate(new Date()),
      "issueDate": this.convertDate(new Date()),
      "status": cardObj.status === "DELETED" ? "DELETED" : cardObj.status === "RESERVED" ? "RESERVED" : status ? "ACTIVE" : !status ? "INACTIVE" : cardObj.status,
      "allocated": allocated,
      "cardIndex": 0
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosVisitor.post(apiConfig.CORPORATE_CARD_UPDATE, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.getAllCards();
        }else{
          common.warningAlert(response.data.message, 1);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.updateCard()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  checkValidate = () => {
    let {allocated, cardIndex, status, updateCard, passId, selected_branch} = this.state;

    if (passId.trim() === "" || cardIndex === "" || selected_branch === "") {
      common.notifyMessage("Please Fill All Required Fields!");
    } else {
      swal({
        title: updateCard ? "Do you want to update this " + passId + " card?" : "Do you want to add this " + passId + " card?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      })
        .then((value) => {
          switch (value) {

            case "action":
              if (updateCard) {
                this.updateCard();
              } else {
                this.addNewCard();
              }
              break;
            default:
          }
        });
    }
  };

  // cardOnChange = (e, {value}) => {
  //   this.setState({
  //     selected_card_list: value
  //   })
  // };

  // floorOnChange = (e, {value}) => {
  //   this.setState({
  //     floor: value,
  //     selected_card_list: []
  //   });
  //   const headers = {
  //     "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
  //   };
  //
  //   this.props.spinnerHandler(true);
  //   axiosVisitor.get(`corporate/branch/building/floor/` + value + `/card`, {headers: headers})
  //     .then(response => {
  //       if (response.data.success) {
  //         let cardId_list = [];
  //         if (response.data.cards.length !== 0) {
  //           response.data.cards.map((card, index) => {
  //             cardId_list.push(card.cardId)
  //           })
  //         }
  //         this.setState({
  //           selected_card_list: cardId_list,
  //           floor: value
  //         })
  //       }
  //     })
  //     .catch(async error => {
  //       let result = await common.checkErrorResponse(error);
  //       if (result === 1) {
  //         this.floorOnChange(e, {value})
  //       }
  //     })
  //     .finally(fin => {
  //       this.props.spinnerHandler(false);
  //     });
  // };

  // buildingOnChange = (e, {value}) => {
  //   let selectedBuilding = null;
  //   this.state.building_list.map((building, index) => {
  //     if (building.buildingId === value) {
  //       selectedBuilding = building
  //     }
  //   });
  //
  //   const floor_options = [];
  //   if (selectedBuilding.floors.length !== 0) {
  //     selectedBuilding.floors.map((element, index) => {
  //       floor_options.push({
  //         key: element.floor_id,
  //         text: element.description,
  //         value: element.floor_id,
  //         image: {avatar: true, src: floor_icon},
  //       })
  //     })
  //   }
  //
  //   this.setState({
  //     floor_options: floor_options,
  //     building: value,
  //     selected_card_list: []
  //   });
  // };

  getBuilding = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let coperateId = this.props.usr_obj.corporateId;

    // Get All Buildings Of Corporate
    axiosTags.get(apiConfig.CORPORATE_BUILDINGS(coperateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            building_list: response.data.buildingList
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getBuilding()
        }
      })
      .finally(fin => {
      });
  };

  changeCardStatusHandler_ = (id, type) => {
    let status = "INACTIVE";
    if (type === "INACTIVE") {
      status = "ACTIVE";
    }
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    // Get All Buildings Of Corporate
    axiosVisitor.patch(apiConfig.CORPORATE_CARD_CHANGE_STATE({cardId:id,status:status}),null, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.getAllCards()
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.changeCardStatusHandler_(id, type)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  changeCardStatusHandler = (id, type) => {
    swal({
      title: "Do you want to change card status?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.changeCardStatusHandler_(id, type);
          break;
        default:
          break;
      }
    });
  };

  // clearCards = () => {
  //   this.setState({
  //     selected_card_list: [],
  //     building: '',
  //     floor: ''
  //   })
  // };

  // proceed = () => {
  //   if (this.state.floor === '' || this.state.selected_card_list.length === 0) {
  //     if (this.state.floor === '') {
  //       common.notifyMessage("Please choose floor")
  //     } else if (this.state.selected_card_list.length === 0) {
  //       common.notifyMessage("Please choose cards")
  //     }
  //   } else {
  //     swal({
  //       title: "Do you want to set cards to floor?",
  //       icon: are_you_sure_icon,
  //       closeOnClickOutside: false,
  //       buttons: {
  //         cancel: 'Cancel',
  //         dangerMode: {
  //           text: "Okay",
  //           value: "action",
  //           className: "okay-btn"
  //         }
  //       },
  //     })
  //       .then((value) => {
  //         switch (value) {
  //           case "action":
  //             this.proceed_(false);
  //             break;
  //           default:
  //         }
  //       });
  //   }
  // };

  // proceed_ = (type) => {
  //   this.props.spinnerHandler(true);
  //   const headers = {
  //     "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
  //     "ApplyCardToMultipleFloors":type
  //   };
  //
  //   axiosVisitor.post(`corporate/branch/building/floor/` + this.state.floor + `/card`, this.state.selected_card_list, {headers: headers})
  //     .then(response => {
  //       if (response.data.success) {
  //         this.clearCards()
  //         common.warningAlert("Card successfully applied!", 0);
  //       }else{
  //         if(response.data.error_code === 603){
  //           swal({
  //             title: response.data.message,
  //             icon: are_you_sure_icon,
  //             closeOnClickOutside: false,
  //             buttons: {
  //               cancel: 'Cancel',
  //               dangerMode: {
  //                 text: "Okay",
  //                 value: "action",
  //                 className: "okay-btn"
  //               }
  //             },
  //           })
  //             .then((value) => {
  //               switch (value) {
  //                 case "action":
  //                   this.proceed_(true);
  //                   break;
  //                 default:
  //               }
  //             });
  //         }else{
  //           common.warningAlert(response.data.message, 1)
  //         }
  //       }
  //     })
  //     .catch(async error => {
  //       let result = await common.checkErrorResponse(error);
  //       if (result === 1) {
  //         this.proceed_();
  //       }
  //     })
  //     .finally(fin => {
  //       this.props.spinnerHandler(false);
  //     })
  // };

  deleteCard_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitor.delete(apiConfig.CORPORATE_CARD_SELECT(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Card successfully deleted", 0);
          this.getAllCards();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteCard_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteCard = (id, name) => {
    swal({
      title: "Do you want to delete this card? First please enter \"" + name + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value === name) {
          this.deleteCard_(id)
        } else {
          common.warningAlert("Can't delete card", 1)
        }
      });
  };

  getAllBranch = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let branch_options = [];
          if (response.data.branchList.length !== 0) {
            response.data.branchList.map((branch, index) => {

              const obj = {
                key: index,
                text: branch.name,
                value: branch.branchId
              };
              branch_options.push(obj)
            })
          }
          this.setState({
            branch_list: branch_options
          })
        } else {
          this.setState({
            branch_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    // this.getBuilding();
    this.getAllBranch();
    this.getAllCards();
  }

  dropDownChange = name => (event, {value,label}) => {
    if (this.state.isModal) {
      this.state.selectedBulkEdit.branch_ = value
      this.forceUpdate();
    } else {
      this.setState({ selected_branch: value })
    }
  };

  onFilesChange = name => files => {
    if (files.length !== 0) {
      this.onFileChange(name, files[0]);
    } else {
      message.error("Please choose valid file type!");
    }
  };
  onFileChange = async (name, e) => {
    const textDataUrl = await readFile(e);
    this.setState({
      isSpin: false,
      [name]: textDataUrl,
      json: this.base64Decode(textDataUrl, "CSV")
    });
  };
  base64Decode = (bytes, file) => {
    try {
      let split = bytes.split("base64,");
      let decode = base64.decode(split[1]);
      return this.csvToJson(decode);
    } catch (e) {
      console.log("exception", e);
      message.error("Please select " + file + " file!");
    }
  };
  csvToJson = (csv) => {
    try{
      this.setState({isSpin: true});
      let lines = csv.split("\n");
      let result = [];

      let headers = ["branchName", "passNumber", "allocatedTo", "cardIndex"];
      for (let i = 1; i < lines.length; i++) {
        let obj = {};
        let currentline = lines[i].split(",");
        if (currentline.length > 1) {
          for (let j = 0; j < headers.length; j++) {
            let value = currentline[j].trim();
            if (value.toString() === "") {
              value = "";
            }
            obj[headers[j]] = value;
          }
          result.push(obj);

          // if (obj.hostBMobile !== undefined) {
          //   result.push(obj);
          // }
        }
      }
      if (result.length === 0) {
        common.notifyMessage("Empty file!")
      }
      return result;
    }catch(error){
      common.notifyMessage("Invalid file!");
      return [];
    }
  };

  removeFromBulk =(id) => {
    this.state.json.splice(id,1)
    this.forceUpdate();
  }

  handleModal = (type,data) => {

    let temp = null
    if (data !== null) {
      temp = {
        id_:data.id,
        branch_:data.branchObj,
        passNumber_:data.passNumber,
        cardIndex_:data.cardIndex,
        allocatedTo_:data.allocatedTo
      }
    }
    switch (type) {
      case 'open':
        this.setState({ isModal: true, json:[]})
        break
      case 'close':
        this.setState({ isModal: false, selectedBulkEdit:temp })
        break
      case 'edit':
        this.setState({ selectedBulkEdit:temp })
        break
      case 'done':
        let data = this.state.selectedBulkEdit
        if (data.passNumber_.trim() === "" || data.cardIndex_ === "" || data.branch_ === "") {
          common.notifyMessage("Please Fill All Required Fields!");
        } else {
          this.state.json[data.id_].passNumber = data.passNumber_
          this.state.json[data.id_].cardIndex = data.cardIndex_
          this.state.json[data.id_].allocatedTo = data.allocatedTo_
          this.state.json[data.id_].branchObj = data.branch_
          this.setState({ selectedBulkEdit:null })
        }
        break
    }
  }

  saveBulk = () => {

    if (this.state.json.length !== 0) {
      let valid = false
      const data = []
      this.state.json.map(item => {
        if (item.branchObj === undefined || item.passNumber.trim() === '' || item.cardIndex.trim() === '') {
          valid = true
        }

        data.push({
          "did": item.cardIndex.toString(),
          "uid": null,
          "passId": item.passNumber.trim(),
          "regDate": this.convertDate(new Date()),
          "issueDate": this.convertDate(new Date()),
          "status": "ACTIVE",
          "allocated": item.allocatedTo,
          "cardIndex": 0,
          "branchId":item.branchObj
        })

      })
      if (valid) {
        message.error("Please check again, the bulk list contain invalid data.");
        return
      }

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      const obj = {cardList:data}
      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      this.props.spinnerHandler(true);
      axiosVisitor.put(apiConfig.CORPORATE_BULK_CARD_ADD(corporateId), obj, {headers: headers})
        .then(response => {
          if (response.data.success) {
            common.warningAlert(response.data.message, 0);
            this.setState({ json:[], isModal:false })
            this.getAllCards();
          }else{
            common.warningAlert(response.data.message, 1);
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.updateCard()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        });

    }
  }


  render() {
    let building_options = [];
    let rows = [];
    let rows_bulk = [];

    if (this.state.building_list.length !== 0) {
      this.state.building_list.map((building, index) => {
        building_options.push({
          key: index,
          text: building.name,
          value: building.buildingId,
          image: {avatar: true, src: building_icon},
        })
      })
    }

    if (this.state.all_cards.length !== 0) {
      this.state.all_cards.map((card, index) => {
        if (card.status === "ACTIVE" || card.status === "INACTIVE" || card.status === "RESERVED") {
          rows.push({
            passId: card.passId,
            allocated: card.allocated,
            cardIndex: card.did,
            status:
              card.status === "ACTIVE" || card.status === "INACTIVE" ?
                <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                          checked={card.status === "ACTIVE"}
                          onChange={() => this.changeCardStatusHandler(card.cardId, card.status)} toggle
                          label={""}/> : card.status
            ,
            regDate: card.regDate,
            more:
              card.status === "ACTIVE" || card.status === "INACTIVE" ?
                <div>
                  <SementicBtn circular icon='edit' onClick={() => this.setState({
                    selected_branch: card.branch.branchId,
                    allocated: card.allocated,
                    cardIndex: card.did,
                    status: card.status === "ACTIVE" ? true : card.status === "INACTIVE" ? false : null,
                    updateCard: true,
                    passId: card.passId,
                    cardObj: card
                  })}/>
                  <SementicBtn className="cus-btn" circular icon='trash alternate'
                               onClick={() => this.deleteCard(card.cardId, card.passId)}/>
                </div> : null
          })
        }
      })
    }

    if (this.state.json.length !== 0) {
      this.state.json.map((item,index)=> {

        item['id'] = index

        let isBranchValid = false
        let tempBranchName = item.branchName

        if (this.state.branch_list.length !== 0) {
          this.state.branch_list.map(branch => {
            if (item.branchObj === undefined) {
              if (branch.text.toLowerCase() === item.branchName.toLowerCase()) {
                isBranchValid = true
                item['branchObj'] = branch.value
                tempBranchName = branch.text
              }
            } else {
              if (branch.value === item.branchObj) {
                isBranchValid = true
                tempBranchName = branch.text
              }
            }
          })
        }

        rows_bulk.push({
          branchName:<div style={{color:isBranchValid ? null : 'red'}}>{tempBranchName}</div>,
          passId:item.passNumber,
          allocated:item.allocatedTo,
          cardIndex:item.cardIndex,
          more:<>
            <SementicBtn circular icon='edit' onClick={() => this.handleModal('edit', item)}/>
            <SementicBtn className="cus-btn" circular icon='trash alternate' onClick={() => this.removeFromBulk(index)}/>
          </>
        })
      })
    }

    let cards_table_data = {columns: col, rows: rows};

    let bulk_table_data = {columns: col_bulk, rows: rows_bulk};

    let card_options = [];
    if (this.state.all_cards.length !== 0) {
      this.state.all_cards.map((card, index) => {
        card_options.push({
          key: card.cardId,
          text: card.passId,
          value: card.cardId,
          image: {avatar: true, src: pass_icon}
        });
      })
    }

    return (
      <Row>
        <Col lg={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col xs="7" lg={"7"} md={"7"}><p>Manage Card Details</p></Col>
                <Col xs="5" lg={"5"} md={"5"} style={{textAlign:'end'}}>
                  <p id={'bulk-link'} onClick={() => this.handleModal('open', null)}> Manage Bulk Cards</p>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs="6" lg={"6"} md={"6"} className={"padd_grap"}>
                  <Row>
                    <Col lg={12}>
                      <Col className={"none-padding"}>
                        <Lbl required>Choose Branch</Lbl>
                        <DrpDwn
                          // multiple
                          disabled={this.state.updateCard}
                          placeholder={"Branch"}
                          options={this.state.branch_list}
                          value={this.state.selected_branch}
                          onChange={this.dropDownChange('branch')}
                        />
                      </Col>
                      <br/>
                      <Form>
                        <Form.Group widths='equal'>
                          <LabelInput
                            required
                            tagText={"Pass Number"}
                            placeholder={"Pass id"}
                            value={this.state.passId}
                            onChange={this.handleChange('passId')}
                          />
                        </Form.Group>

                      </Form>
                    </Col>

                    <Col lg={12}>
                      <Form>
                        <Form.Group widths='equal'>
                          <LabelInput
                            // required
                            tagText={"Allocated To"}
                            placeholder={"Allocated"}
                            value={this.state.allocated}
                            onChange={this.handleChange('allocated')}
                          />
                        </Form.Group>

                      </Form>
                    </Col>

                  </Row>
                </Col>
                <Col xs="6" lg={"6"} md={"6"}>
                  <Col lg={12} style={{marginTop:'10px'}}>
                      <Form>
                        <Form.Group widths='equal'>
                          <LabelInput
                            required
                            tagText={"Card Index"}
                            placeholder={"Card Index"}
                            value={this.state.cardIndex}
                            onChange={this.handleChange('cardIndex')}
                          />
                        </Form.Group>
                      </Form>

                    </Col>

                    <Col lg={12}>
                      <br/>
                      {
                        this.state.status !== null ?
                          <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                    checked={this.state.status}
                                    onChange={() => this.setState({status: !this.state.status})}
                                    toggle
                                    label={this.state.status ? 'Active' : 'In-Active'}/> : null
                      }

                    </Col>
                </Col>

              </Row>
              <center>
                <Button
                  className="submit-btn"
                  onClick={this.checkValidate}
                >{this.state.updateCard ? "Update Card" : "Add Card"}</Button>
                &nbsp;&nbsp;
                <Tooltip placement="topLeft" title="Clear input fields">
                  <SementicBtn circular icon='refresh' onClick={this.clearFeilds}/>
                </Tooltip>
              </center>
            </CardBody>
          </Card>

          {/*change - (client decided)*/}

          {/*<Card>*/}
          {/*<CardHeader>Manage Cards & Floors (Select building and choose floor)*/}
          {/*</CardHeader>*/}
          {/*<CardBody>*/}
          {/*<Row>*/}
          {/*<Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>*/}
          {/*<Row>*/}
          {/*<Col lg={12}>*/}
          {/*<Form>*/}
          {/*<Form.Group widths='equal'>*/}
          {/*<DrpDwn*/}

          {/*tagText={"Select building"}*/}
          {/*value={this.state.building}*/}
          {/*placeholder={"Select building"}*/}
          {/*options={building_options}*/}
          {/*onChange={this.buildingOnChange}*/}
          {/*/>*/}
          {/*</Form.Group>*/}
          {/*</Form>*/}
          {/*</Col>*/}

          {/*<Col lg={12}>*/}
          {/*<Form>*/}
          {/*<Form.Group widths='equal'>*/}
          {/*<DrpDwn*/}
          {/*required*/}
          {/*tagText={"Choose floor"}*/}
          {/*value={this.state.floor}*/}
          {/*placeholder={"Choose floor"}*/}
          {/*options={this.state.floor_options}*/}
          {/*onChange={this.floorOnChange}*/}
          {/*/>*/}
          {/*</Form.Group>*/}
          {/*</Form>*/}
          {/*</Col>*/}
          {/*<br/>*/}
          {/*<Col lg={12}>*/}
          {/*<Form>*/}
          {/*<Form.Group widths='equal'>*/}
          {/*<DrpDwn*/}
          {/*required*/}
          {/*tagText={"Select multiple cards"}*/}
          {/*multiple*/}
          {/*value={this.state.selected_card_list}*/}
          {/*placeholder={"Choose cards"}*/}
          {/*options={card_options}*/}
          {/*onChange={this.cardOnChange}*/}
          {/*/>*/}
          {/*</Form.Group>*/}
          {/*</Form>*/}
          {/*</Col>*/}

          {/*</Row>*/}
          {/*</Col>*/}
          {/*</Row>*/}
          {/*<center>*/}
          {/*<Button*/}
          {/*className="submit-btn"*/}
          {/*onClick={this.proceed}*/}
          {/*>Proceed</Button>*/}

          {/*</center>*/}
          {/*</CardBody>*/}
          {/*</Card>*/}
        </Col>

        <Col lg={12}>
          <Card>
            <CardHeader>All Cards Details</CardHeader>
            <CardBody>
              <Spin spinning={this.state.isSpin} delay={10}
                    indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                <MDBDataTable
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  bordered
                  hover
                  data={cards_table_data}/>
              </Spin>
            </CardBody>
          </Card>
        </Col>

        {
          this.state.isModal &&
          <MDBModal isOpen={this.state.isModal} toggle={() => this.handleModal('close',null)} size="lg">
            <MDBModalHeader className={"title"} toggle={() => this.handleModal('close',null)}>Manage Bulk Cards</MDBModalHeader>
            <MDBModalBody>
              {
                this.state.selectedBulkEdit !== null && <Card>
                  <CardBody>
                    <p style={{fontSize:'15px', fontWeight:700, margin:0}}>Edit Record</p>
                    <Row>
                      <Col lg={12}>
                        <Lbl required>Choose Branch</Lbl>
                        <DrpDwn
                          // multiple
                          placeholder={"Branch"}
                          options={this.state.branch_list}
                          value={this.state.selectedBulkEdit.branch_ !== undefined ? this.state.selectedBulkEdit.branch_ : ''}
                          onChange={this.dropDownChange('branch_')}
                        />
                      </Col>
                      <Col lg={12} style={{paddingTop:'1rem'}}>
                        <Form>
                          <Form.Group widths='equal'>
                            <LabelInput
                              required
                              tagText={"Pass Number"}
                              placeholder={"Pass id"}
                              value={this.state.selectedBulkEdit.passNumber_}
                              onChange={ this.handleChange('passNumber_')}
                            />
                          </Form.Group>

                        </Form>
                      </Col>
                      <Col lg={12}>
                        <Form>
                          <Form.Group widths='equal'>
                            <LabelInput
                              // required
                              tagText={"Allocated To"}
                              placeholder={"Allocated"}
                              value={this.state.selectedBulkEdit.allocatedTo_}
                              onChange={this.handleChange('allocatedTo_')}
                            />
                          </Form.Group>

                        </Form>
                      </Col>
                      <Col lg={12}>
                        <Form>
                          <Form.Group widths='equal'>
                            <LabelInput
                              required
                              tagText={"Card Index"}
                              placeholder={"Card Index"}
                              value={this.state.selectedBulkEdit.cardIndex_}
                              onChange={this.handleChange('cardIndex_')}
                            />
                          </Form.Group>
                        </Form>

                      </Col>
                    </Row>
                    <div align="right">
                      <Button color='warning' onClick={() => this.handleModal('done',null)}>Done</Button>
                    </div>
                  </CardBody>
                </Card>
              }

              <p className={"offline-warning-txt"}>(Download the <a href={csvFormat}>csv_format.csv</a> file. Modify the
                contents and upload)</p>
              <div id='bulk-file-div'>
                <Files
                  className='files-dropzone-bulk'
                  onChange={this.onFilesChange("file")}
                  accepts={["text/csv", ".csv"]}
                  multiple={false}
                  maxFileSize={10000000}
                  minFileSize={0}
                  clickable
                >
                  <button className={"file-uploader"}>Choose CSV file&nbsp;&nbsp;
                    <Icon name={"upload"}/>
                  </button>
                </Files>
              </div>

              <Spin spinning={this.state.isSpin} delay={10}
                    indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                <MDBDataTable
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  bordered
                  hover
                  data={bulk_table_data}/>
              </Spin>
              {
                this.state.json.length !== 0 &&
                <div align="center" style={{paddingTop:'2rem'}}>
                  <Button className="submit-btn yellow-btn" onClick={() => this.saveBulk()}>Save All</Button>
                </div>
              }


            </MDBModalBody>
          </MDBModal>
        }

      </Row>
    );
  }
}

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}


const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});

const col = [
  { label: 'Pass Number', field: 'passId' },
  { label: 'Allocated', field: 'allocated' },
  { label: 'Card Index', field: 'cardIndex' },
  { label: 'Status', field: 'status' },
  { label: 'Reg Date', field: 'regDate' },
  { label: 'Actions', field: 'more'}
];

const col_bulk = [
  { label: 'Branch Name', field: 'branchName' },
  { label: 'Pass Number', field: 'passId' },
  { label: 'Allocated', field: 'allocated' },
  { label: 'Card Index', field: 'cardIndex' },
  { label: 'Actions', field: 'more'}
];

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
